import { question1 } from "./question1";
import { question2 } from "./question2";
import { question3 } from "./question3";

export const questions = {
	question1,
	question2,
	question3,
}